import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface UserMini {
    id: string;
    name: string;
    image?: string;
}

/**
 * A global cache for storing users metadata, so it doesn't need to constantly be queried.
 */
const slice = createSlice({
    name: 'users',
    initialState: {} as Record<string, UserMini>,
    reducers: {
        upsertUsers(state, action: PayloadAction<UserMini[]>) {
            action.payload.forEach(u => (state[u.id] = u));
        },
    }
});

export const { upsertUsers } = slice.actions;
export default slice.reducer;